/*
 * create by nguyendx 2017/10/05
 */
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { BrowserModule } from "@angular/platform-browser";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import {
  ConfirmDialogModule,
  GrowlModule,
  TooltipModule,
} from "primeng/primeng";
import { HelperModule } from "../../../../common/helper/helper.module";
import { FilterProductsModule } from "../../../../layout/filter-products/filter-products.module";
import { LogScanComponent } from "./log_scan.component";
import { LogsService } from "./logs.service";
import { BsDatepickerModule, ModalModule } from 'ngx-bootstrap';
import { SelectModule } from "ng-select";
import { PopupModule } from "../../qrcode/popup/popup.module";
import { AgmCoreModule } from "@agm/core";
import { ImageService } from "../../../imageService";
import { ErrorStampScanningComponent } from './tab2/error-stamp-scanning.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    ConfirmDialogModule,
    GrowlModule,
    TooltipModule,
    BrowserModule,
    HelperModule,
    BsDatepickerModule.forRoot(),
    SelectModule,
    FilterProductsModule,
    ModalModule,
    AgmCoreModule,
    PopupModule,
    TranslateModule
  ],
  declarations: [LogScanComponent, ErrorStampScanningComponent],
  exports: [LogScanComponent],
  providers: [LogsService, ImageService],
})
export class LogsModule { }



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/logs/log.module.ts